import styled from "styled-components";
import colors from "../constants/colors";

const sans = "var(--sans)";
const serif = "var(--serif)";

export const BlackH1 = styled.div`
  color: var(--ink);
  font-family: ${serif};
  font-size: 40px;
  font-weight: 500;
  line-height: 1.1;
`;

export const WhiteH1 = styled.div`
  color: var(--cream);
  font-family: ${serif};
  font-size: 32px;
  font-weight: 500;
  line-height: 1.2;
  text-align: center;
`;

export const RedH1 = styled.div`
  color: var(--maroon);
  font-family: ${serif};
  font-size: 40px;
  font-weight: 500;
  line-height: 1.1;
`;

export const BlackH2 = styled.div`
  color: var(--ink);
  font-family: ${serif};
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
`;

export const RedH2 = styled.div`
  color: var(--maroon);
  font-family: ${serif};
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
`;

export const WhiteH2 = styled.div`
  color: var(--cream);
  font-family: ${serif};
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
`;

export const BlackH3 = styled.div`
  color: var(--ink);
  font-family: ${sans};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
`;

export const WhiteH3 = styled.div`
  color: var(--cream);
  font-family: ${sans};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
`;

export const RedH3 = styled.div`
  color: var(--maroon);
  font-family: ${sans};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
`;

export const WhiteBody = styled.div`
  color: var(--cream);
  font-family: ${sans};
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5;
`;

export const WhiteBodyBold = styled.div`
  color: var(--cream);
  font-family: ${sans};
  font-size: 15px;
  font-weight: 600;
  line-height: 1.5;
`;

export const RedBody = styled.div`
  color: var(--maroon);
  font-family: ${sans};
  font-size: 15px;
  font-weight: 500;
  line-height: 1.5;
`;

export const BlackBody = styled.div`
  color: var(--ink);
  font-family: ${sans};
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5;
`;

export const BlackLightText = styled.div`
  color: var(--ink-soft);
  font-family: ${sans};
  font-size: 14px;
  font-weight: 300;
  line-height: 1.4;
`;

export const WhiteThinInitials = styled.div`
  font-family: ${sans};
  font-size: 18px;
  font-weight: 400;
  color: var(--cream);
`;

export const WhiteThinH2 = styled.div`
  font-family: ${sans};
  font-size: 36px;
  font-weight: 300;
  line-height: 1.2;
  color: var(--cream);
`;

export const BlackThinH3 = styled.div`
  font-family: ${sans};
  font-size: 24px;
  font-weight: 300;
  line-height: 1.2;
  color: var(--ink);
`;

export const ErrorText = styled.div`
  color: var(--maroon);
  font-family: ${sans};
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
`;
